// About.js
import React from 'react';
import { Typography, Box } from '@mui/material';
import AboutCard from './AboutCard';
import MassieImage from '../massie2.jpeg';
import RLCImage from '../rlc_logo_new_color_200x200.png';
import RandImage from '../rand.jpg';
import RonImage from '../ronpaul.jpg';

const datax = {
  0: {
    'title': 'We Are Activists!',
    'summary': 'The RLC was founded in 1991 by libertarian activists seeking to influence the GOP. Past chairmen have included Congressman Ron Paul.',
    'image': RonImage
  },
  1: {
    'title': 'We Are Members!',
    'summary': 'The RLC is a grassroots membership organization working within the Republican Party to advance the principles of individual rights, limited government, and free markets.', 
    'image': RLCImage
  },
  2: {
    'title': 'Support the Caucus Supported by Budget Hawk Heroes',
    'summary': '"Libertarianism is at the heart of the Republican Platform." - Congressman Thomas Massie',
    'image': MassieImage
  },
  3: {
    'title': 'We Are Instrumental!',
    'summary': '“The RLC was instrumental in my decision to run for public office and helping me get elected. I don’t know if I would be where I am today without their support over the years.” - Senator Rand Paul',
    'image': RandImage
  }
}

const About = () => {
  return (
    <div>
       <Box sx={{ padding: '16px' }}>
      <Typography variant="h5" gutterBottom>
        About
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px', // Space between cards
          justifyContent: 'flex-start', // Align cards to the left
          // Responsive design for mobile
          '@media (max-width: 600px)': {
            flexDirection: 'column',
            alignItems: 'center', // Center cards on mobile
            gap: '8px', // Smaller gap for mobile
            padding: '8px', // Additional padding for mobile
          },
        }}
      >
        {Object.keys(datax).map((item, index) => (
          <AboutCard key={item} item={datax[item]} />
        ))}
      </Box>
    </Box>
    <hr />
    </div>
  );
};

export default About;